import { AUTH_STORAGE_NAMESPACE } from "./namespaces";
import { createSessionStorage, createStorage } from "./storage";
import { createSyncStorage } from "./syncStorage";

// Canonical definition lives in `./namespaces` (dependency-free); re-exported
// here so existing `@medbillai/app/lib/storage` consumers are unaffected.
export { AUTH_STORAGE_NAMESPACE };
export const authStorage = createStorage({ namespace: AUTH_STORAGE_NAMESPACE });

// App download Web storage
export const downloadStorage = createStorage({
  namespace: "medbillai-downloads",
});

// User segmentation data storage
export const userSegmentationStorage = createSessionStorage({
  namespace: "medbillai-user-segmentation",
});

// Web to mobile modal storage
export const escalationModalStorage = createStorage({
  namespace: "medbillai-web-to-mobile-modal",
});

// Anonymous session storage - holds the signed JWT from the pre-auth flow
export const anonymousSessionStorage = createStorage({
  namespace: "medbillai-anonymous-session",
});

// Natera intake funnel answers, held between the landing page and the case that gets
// created after the member authenticates. Local rather than session storage on purpose:
// the magic link is opened from an email client, which is a new tab at best, and the
// intended path that routes them back is itself in localStorage.
export const nateraIntakeStorage = createStorage({
  namespace: "medbillai-natera-intake",
});

export const flagOverrideStorage = createSyncStorage({
  namespace: "medbillai-flag-overrides",
});

// Which activation steps a guided-chat Natera case has already reported. The
// steps are read off the case timeline, so without a record that outlives the
// tab every relaunch would re-report the walkthrough. Sync so the first render
// after a reload already knows; nothing here is sensitive.
export const nateraChatIntakeTrackingStorage = createSyncStorage({
  namespace: "medbillai-natera-chat-intake-tracking",
});

// Add other storage instances as needed
// export const someOtherStorage = createStorage({ namespace:
// "some-other-namespace" });

// The newest deductible or out-of-pocket movement the user opened on each plan,
// keyed by membership id. Sync so the notice never flashes on a reload.
export const coverageMovementStorage = createSyncStorage({
  namespace: "medbillai-coverage-movement",
});
